import { createSlice } from "@reduxjs/toolkit";
import {
  getFaqQuizThunk,
  updateFaqQuizThunk,
  deleteFaqQuizThunk,
} from "./FaqThunk";

const initialState = {
  data: [],
  sections: [],
  loading: false,
  status: "",
  message: "",
  usertype: "fellow",
  language: "od",
};

const FaqSlice = createSlice({
  name: "FaqSlice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    section_change: (state, action) => {
      state.sections = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
  },
  extraReducers: {
    [getFaqQuizThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getFaqQuizThunk.fulfilled]: (state, action) => {
      state.data = action?.payload?.resp;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getFaqQuizThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [updateFaqQuizThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateFaqQuizThunk.fulfilled]: (state, action) => {
      state.data = action?.payload?.resp;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateFaqQuizThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { usertype_change, language_change, section_change } =
  FaqSlice.actions;

export default FaqSlice.reducer;
